import { jsx as r } from "react/jsx-runtime";
import { useCallback as i } from "react";
import { u as s } from "./styled-components.browser.esm-3eb04950.js";
import { D as c } from "./DuplicateIcon-a73a111a.js";
import { IconContainer as m } from "./IconContainer.js";
const D = ({ onClick: o, ...e }) => {
  const a = i(
    (t) => {
      const n = t.currentTarget;
      return n.classList.add("icon-active"), window.setTimeout(() => {
        n.classList.remove("icon-active");
      }, 230), o(t);
    },
    [o]
  );
  return /* @__PURE__ */ r(m, { children: /* @__PURE__ */ r(l, { onClick: a, onMouseDown: (t) => t.preventDefault(), ...e }) });
}, l = s(c)`
  transition: transform 0.15s ease-in-out;
  &.icon-active {
    transform: scale(1.3);
}
`;
export {
  D as default
};
//# sourceMappingURL=IconAnimated.js.map
